import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AiOutlineLoading } from 'react-icons/ai';
import { resetProductTransaction } from '../../../../features/scanproduct/scanProduct';
import { useDispatch } from 'react-redux';
import Styles from './FormButtons.module.scss';

const FormButtons = ({ loading, onSubmit, transactionId, isEdit = false }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleCancel = () => {
    navigate('/products');
    if (!transactionId) {
      dispatch(resetProductTransaction());
    }
  };

  return (
    <div className={`${Styles.buttons}`}>
      <button
        type="button"
        onClick={onSubmit}
        disabled={loading}
        style={{
          opacity: loading ? 0.6 : 1,
          cursor: loading ? 'not-allowed' : 'pointer',
        }}
      >
        {loading ? (
          <AiOutlineLoading className={`${Styles.spinner}`} />
        ) : (
          isEdit ? "Update" : "Create"
        )}
      </button>
      <button type="button" onClick={handleCancel}>
        Cancel
      </button>
    </div>
  );
};

export default FormButtons;